module.exports = __webpack_public_path__ + "img/group_discussion.0f29f6d6.jpg";